import React from "react";
import { IoStarSharp } from "react-icons/io5";
import StartIcon from "../../../Common/svg/starticon";
const StarRatings = ({ rating }) => {
  const fullStars = Math.floor(rating); // 3
  const hasHalfStar = rating - fullStars >= 0.5;
  return (
    <div>
      {/* Full stars */}
      {[...Array(fullStars)].map((_, index) => (
        <span
          key={`full-${index}`}
          style={{
            color: "#FFD700",
            width: "14px",
            height: "14px",
            display: "inline-block",
            marginLeft:"5px"
          }}
        >
        <StartIcon/>
        </span>
      ))}

      {/* Half star */}
      {hasHalfStar && (
        <span key="half" style={{ color: "#FFD700" }}>
        <StartIcon/>
        </span>
      )}
      <span className="desc"> ({fullStars})</span>
    </div>
  );
};

export default StarRatings;
